import { IDeleteServiceOps, IServiceOperation } from '../../../../models/index';
import {
  addServiceOperations,
  clearServiceOperations,
  deleteServiceOperations,
  statusMsgClearMaping,
  updateServiceOperations
} from '../../../reducer/services/ServiceOperationReducer';
import {
  AddServiceOperationsSuccess,
  ClearServiceOperations,
  DeleteServiceOperations,
  StatusMsgClearMaping,
  StatusMsgClearMapingPayload,
  UpdateServiceOperations,
  UpdateServiceOperationsPayload
} from '../../types/services/ServiceOperationTypes';

/**
 * Adds Service operations
 * @param reqObject : Payload
 */
export const addServiceOperation = (
  payload: IServiceOperation
): AddServiceOperationsSuccess => ({
  type: addServiceOperations.type,
  payload
});

/**
 * Update Service Operation
 * @param payload : data
 */
export const updateServiceOperation = (
  payload: UpdateServiceOperationsPayload
): UpdateServiceOperations => ({
  type: updateServiceOperations.type,
  payload
});

/**
 * Delete Service Operation
 * @param payload : IDeleteServiceOps
 */

export const deleteServiceOperation = (
  payload: IDeleteServiceOps
): DeleteServiceOperations => ({
  type: deleteServiceOperations.type,
  payload
});

/**
 * Clear Service Operation saga action
 */
export const clearServiceOperationList = (): ClearServiceOperations => ({
  type: clearServiceOperations.type
});

export const statusMsgClearMapings = (
  payload: StatusMsgClearMapingPayload
): StatusMsgClearMaping => ({
  type: statusMsgClearMaping.type,
  payload
});
